import { React, useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { useSelector, useDispatch } from "react-redux";
import QuestDataService from "../services/QuestDataService";
import { getQuestList, getQuestListBySeasonId } from "../redux/slices/QuestSlice";
import { changeSelectedSeasonIdForQuestFilter } from "../redux/slices/SeasonSlice";
import { getUsersInfos } from "../redux/slices/UserSlice";
import QuestValidationTable from "../components/table/QuestValidationTable";
import { v4 as uuid } from "uuid";
import { Toaster } from "react-hot-toast";
import { Spinner } from "reactstrap";
import "../components/questValidation/questValidation.css";
import { useLocation, useSearchParams } from "react-router-dom";
import { notify } from "../assets/utils/UtilsFunctons";
import useGetSeasonList from "../hooks/useGetSeasonList";
import { SeasonTypeConst } from "../core/constant/seasonType";

const QuestToValidate = () => {
  const { accounts } = useMsal();

  const dispatch = useDispatch();
  const location = useLocation();
  const { refreshQuestPageAfterDecisionUpdating, loading_getQuestList } = useSelector((state) => ({ ...state.questInfos }));
  const { loading_getUsersInfos, usersInfos } = useSelector((state) => ({ ...state.userInfos }));
  const { selectedSeasonIdForQuestFilter } = useSelector((state) => ({ ...state.seasonList }));
  const [currentUserId, setCurrentUserId] = useState(location.state ? location.state?.userId : null);
  const [hasInitializedSeasonFilter, setHasInitializedSeasonFilter] = useState(false);
  const [hasInitializedStatusFilter, setHasInitializedStatusFilter] = useState(false);
  const [refreshPage, setRefreshPage] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const { SeasonList } = useGetSeasonList();

  useEffect(() => {
    if (hasInitializedSeasonFilter) return;

    if (selectedSeasonIdForQuestFilter) {
      setHasInitializedSeasonFilter(true);
      return;
    }

    if (!SeasonList || SeasonList.length === 0) return;

    const currentSeason = SeasonList.find(
      (s) => s.seasonType === SeasonTypeConst.current
    );

    if (currentSeason?.seasonId) {
      dispatch(changeSelectedSeasonIdForQuestFilter(currentSeason.seasonId));
    }

    setHasInitializedSeasonFilter(true);
  }, [SeasonList, selectedSeasonIdForQuestFilter, dispatch, hasInitializedSeasonFilter]);

  useEffect(() => {
    if (hasInitializedStatusFilter) return;

    if (!searchParams.get("questState")) {
      const existingParams = Object.fromEntries(searchParams.entries());

      setSearchParams({
        ...existingParams,
        questState: "1",
      });
    }

    setHasInitializedStatusFilter(true);
  }, [searchParams, setSearchParams, hasInitializedStatusFilter]);

  useEffect(() => {
    // Get the list of quests to validate
    if (selectedSeasonIdForQuestFilter === "__INTER__") {
      dispatch(getQuestList());
    } else if (selectedSeasonIdForQuestFilter) {
      dispatch(getQuestListBySeasonId(selectedSeasonIdForQuestFilter));
    } else {
      dispatch(getQuestList());
    }

    // Get the list of users
    if (location.state) {
      const { userId } = location?.state;
      setCurrentUserId(userId);
    } else {
      setCurrentUserId(null);
    }
    dispatch(getUsersInfos());

    return () => {
      if (window.location.pathname !== "/QuestToValidate") {
        dispatch(changeSelectedSeasonIdForQuestFilter(null));
        setHasInitializedSeasonFilter(false);
        setHasInitializedStatusFilter(false);
      }
    };
  }, [dispatch, refreshQuestPageAfterDecisionUpdating, refreshPage, selectedSeasonIdForQuestFilter]);

  const postQuestDecisionHandler = async (formValue, closeModal) => {
    let questValidationContract = {
      questId: formValue.questId,
      decidedQuestState: formValue.decidedQuestState,
    };
    if (formValue.message.length > 0) {
      questValidationContract = {
        questId: formValue.questId,
        decidedQuestState: formValue.decidedQuestState,
        message: {
          messageId: uuid(),
          parentId: formValue.questId,
          userId: accounts[0].localAccountId,
          text: formValue.message,
        },
      };
    }

    try {
      if (questValidationContract) {
        await QuestDataService.postQuestDecision(questValidationContract);
        notify(1, "Modification apportée avec succés !");
        setRefreshPage(!refreshPage);
      }
    } catch (error) {
      notify(0, error?.response.data.title ?? "une erreur est survenue");
    } finally {
      closeModal();
    }
  };

  return (
    <div>
      <div>
        <Toaster></Toaster>
      </div>
      <h3 className="page-header">Quêtes à valider</h3>
      <div className="row">
        <div className="col-12">
          <div>
            {loading_getQuestList || loading_getUsersInfos ? (
              <div className="quest-validation-spinner">
                <Spinner color="secondary">Loading...</Spinner>
              </div>
            ) : (
              <>
                <QuestValidationTable
                  users={usersInfos}
                  userId={currentUserId}
                  postQuestDecision={postQuestDecisionHandler}
                  setRefreshPage={setRefreshPage}
                  refreshPage={refreshPage}
                ></QuestValidationTable>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestToValidate;
